import { apiConnector } from "../apiConnection";
import {
  createRideEndpoints,
  getRideRequestsEndpoints,
  myRidesEndpoint,
  reqToJoinEndpoint,
  searchRideEndpoints,
  getRideDetailsEndpoint,
  setReqStatusEndpoint,
  cancelRideEndpoints,
  updateRideEndpoints,
  deleteRequestEndpoint,
} from "../apiEndpoints";
import toast from "react-hot-toast";
const login = localStorage.getItem("token");

export const createRideApi = async (
  from,
  to,
  capacity,
  date,
  price,
  vehicleType,
  description,
  recurrence
) => {
  try {
    const localDate = new Date(date); // Local time
    const utcDate = new Date(
      localDate.getTime() - localDate.getTimezoneOffset() * 60000
    );

    const isoDate = utcDate.toISOString();
    const bodyData = {
      from,
      to,
      capacity: parseInt(capacity),
      date: isoDate,
      totalFare: parseInt(price),
      vehicleType,
      description,
      ...(recurrence && { recurrence }),
    };
    const request = {
      url: createRideEndpoints.url,
      method: createRideEndpoints.method,
      bodyData,
      headers: {
        Authorization: `Bearer ${login}`,
      },
    };

    toast.loading("Creating the ride...");
    const res = await apiConnector(request);
    if (res.status != 201) {
      throw new Error(res.data.message || "error occurred");
    }
    toast.dismiss();
    const successMsg = res.data?.count
      ? `${res.data.count} recurring rides created!`
      : "Ride created!";
    toast.success(successMsg);

    return true;
  } catch (error) {
    toast.dismiss();
    toast.error(error.message || "Could not create the ride");
    console.log(error.message);
    return false;
  }
};
export const updateRideApi = async (rideId, formData) => {
  try {
    const bodyData = {};
    if (formData.capacity) bodyData.capacity = parseInt(formData.capacity);
    if (formData.date) bodyData.date = formData.date;
    if (formData.totalFare) bodyData.totalFare = parseInt(formData.totalFare);
    if (formData.vehicleType) bodyData.vehicleType = formData.vehicleType;
    if (formData.description != undefined)
      bodyData.description = formData.description;

    const request = {
      url: `${updateRideEndpoints.url}${rideId}`,
      method: updateRideEndpoints.method,
      bodyData,
      headers: {
        Authorization: `Bearer ${login}`,
      },
    };

    toast.loading("updating...");
    const response = await apiConnector(request);
    if (response.status !== 200)
      throw new Error(response.data.message || "error occurred");
    toast.dismiss();
    toast.success("Ride updated successfully!");
    return response.data;
  } catch (error) {
    toast.dismiss();
    toast.error("Could not update the ride");
    console.error(error);
  }
};
export const cancelRideApi = async (rideId) => {
  try {
    const request = {
      url: cancelRideEndpoints.url + "" + rideId,
      method: cancelRideEndpoints.method,
      headers: {
        Authorization: `Bearer ${login}`,
      },
    };

    toast.loading("Cancelling the ride...");
    const response = await apiConnector(request);
    if (response.status !== 200) {
      throw new Error(response.data.message || "error occuered");
    }
    toast.dismiss();

    toast.success("Ride cancelled successfully!");
    return true;
  } catch (error) {
    toast.dismiss();
    toast.error("Could not cancel the ride");
    console.error(error);
    return false;
  }
};
export const searchRidesApi = async (from, to, date) => {
  try {
    const params = {};
    if (from) params.from = from;
    if (to) params.to = to;
    if (date) params.date = date;

    const request = {
      url: searchRideEndpoints.url,
      method: searchRideEndpoints.method,
      params,
      headers: {
        Authorization: `Bearer ${login}`,
        "Content-Type": "application/json",
      },
    };

    toast.loading("Search for rides...");
    const response = await apiConnector(request);
    if (response.status !== 200)
      throw new Error(response.data.message || "error occuered");
    toast.dismiss();
    return response.data;
  } catch (error) {
    toast.dismiss();
    toast.error("Could not get rides");
    console.error(error);
  }
};
export async function rideRequestsApi() {
  try {
    const request = {
      url: getRideRequestsEndpoints.url,
      method: getRideRequestsEndpoints.method,
      withCredentials: getRideRequestsEndpoints.withCredentials,
      headers: {
        Authorization: `Bearer ${login}`,
      },
    };
    const response = await apiConnector(request);
    if (response.status !== 200)
      throw new Error(response.data.message || "error occuered");
    return response.data;
  } catch (err) {
    toast.dismiss();
    toast.error("Could not fetch ride requests");
  }
}
export const myRidesApi = async () => {
  try {
    const request = {
      method: myRidesEndpoint.method,
      url: myRidesEndpoint.url,
      withCredentials: myRidesEndpoint.withCredentials,
      headers: {
        Authorization: `Bearer ${login}`,
        "Content-Type": "application/json",
      },
    };
    const response = await apiConnector(request);
    if (response.status !== 200)
      throw new Error(response.data.message || "error occuered");

    return response.data;
  } catch (error) {
    toast.dismiss();
    toast.error("Could not fetch rides");
  }
};
export const reqToJoinApi = async (id) => {
  try {
    const bodyData = {
      capacity: 1,
    };
    const request = {
      url: reqToJoinEndpoint.url + "" + id,
      method: reqToJoinEndpoint.method,
      withCredentials: reqToJoinEndpoint.withCredentials,
      bodyData,
      headers: {
        Authorization: `Bearer ${login}`,
      },
    };
    toast.loading("Sending your request to host");
    const response = await apiConnector(request);
    if (response.status !== 201)
      throw new Error(response.data.message || "error occuered");

    toast.dismiss();
    toast.success("Request sent to host");
  } catch (error) {
    toast.dismiss();
    toast.error(error.message);
  }
};

export const getRideDetails = async (id) => {
  try {
    const request = {
      url: `${getRideDetailsEndpoint.url}${id}`,
      method: getRideDetailsEndpoint.method,
      withCredentials: getRideDetailsEndpoint.withCredentials,
      headers: {
        Authorization: `Bearer ${login}`,
        "Content-Type": "application/json",
      },
    };
    const response = await apiConnector(request);
    if (response.status !== 200)
      throw new Error(response.data.message || "error occuered");
    return response.data;
  } catch (error) {
    toast.dismiss();
    toast.error("Could not get ride details");
  }
};

export const setReqStatus = async (rideId, requestId, status) => {
  try {
    const bodyData = {
      status: status.toUpperCase(),
    };
    const request = {
      url: setReqStatusEndpoint.url + "" + rideId + "/" + requestId,
      method: setReqStatusEndpoint.method,
      withCredentials: setReqStatusEndpoint.withCredentials,
      bodyData,
      headers: {
        Authorization: `Bearer ${login}`,
      },
    };
    toast.loading("Updating request status");
    const response = await apiConnector(request);
    if (response.status !== 200)
      throw new Error(response.data.message || "error occuered");

    toast.dismiss();
    toast.success("Ride status updated");
  } catch (error) {
    toast.dismiss();
    toast.error("Could not update ride details");
  }
};
// export const setRequestStatus = async (updated)=>{
//   try {

//   } catch (error) {
//     toast.dismiss();
//     toast.error("Could not update request status");
//     return
//   }
// }

export const deleteRequestApi = async (requestId) => {
  try {
    const request = {
      url: `${deleteRequestEndpoint.url}${requestId}`,
      method: deleteRequestEndpoint.method,
      withCredentials: deleteRequestEndpoint.withCredentials,
      headers: {
        Authorization: `Bearer ${login}`,
      },
    };
    toast.loading("Cancelling the request...");
    const response = await apiConnector(request);
    if (response.status !== 200)
      throw new Error(response.data.message || "error occuered");
    toast.dismiss();
    toast.success("Request cancelled successfully!");
    return true;
  } catch (error) {
    toast.dismiss();
    toast.error("Could not cancel the request");
    console.error(error);
    return false;
  }
};
